import React, { Component, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import UserService from '../services/UserService'
import logoimage from './../assets/images/TranzitLogoV1.png'
import background from './../assets/images/keycloak-bg.png'

const Welcome = () => {
  const [email, setEmail] = useState('')
  const goToKeyClockLogin = () => {
    if (email && email != '') {
      let domain = getDomainFromEmail(email)
      console.log('getDomainFromEmail', domain)
      localStorage.setItem('realm', domain)

      UserService.initKeycloakWithLogin(setItem)
      // UserService.customLogin(email)
    }
  }
  const setItem = () => {
    localStorage.setItem('realm', 'nike')
  }
  const getDomainFromEmail = (email) => {
    let emailDomain = null
    const pos = email.search('@') // get position of domain
    if (pos > 0) {
      emailDomain = email.slice(pos + 1) // use the slice method to get domain name, "+1" mean domain does not include "@"
      let emailDomainArray = emailDomain.split('.')
      emailDomain = emailDomainArray[0]
    }
    return emailDomain
  }
  useEffect(() => {
    console.log('checking is user is login', UserService.keyObj)
  }, [])
  return (
    // <div className="jumbotron">
    //   <h1>Hello Anonymous!</h1>
    //   <p className="lead">Please authenticate yourself!</p>
    //   <p>
    //     <button className="btn btn-lg btn-warning" onClick={() => UserService.doLogin()}>
    //       Login
    //     </button>
    //   </p>
    // </div>
    <div className="bg-light min-vh-100 login-bg" style={{ backgroundImage: `url(${background})` }}>
      {/* <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8} style={{ maxWidth: '500px' }}>
            <CCardGroup>
              <CCard className="p-4 card-pf4">
                <CCardBody className="no-padding">
                  <div className="center" style={{ paddingBottom: '10px' }}>
                    <img className="logo" style={{ width: '200px' }} src={logoimage} />
                  </div>
                  <CForm>
                    <h6 className="center">Login</h6>
                    <CInputGroup className="mb-3" style={{ paddingTop: '20px' }}>
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Username"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </CInputGroup>

                    <CRow style={{ float: 'right' }} className="right-float">
                      <CCol xs={6}>
                        <CButton className="px-4 common-bg white-text" onClick={goToKeyClockLogin}>
                          Next
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer> */}
      <div className="login-pf-page">
        <div id="kc-header" className="login-pf-page-header">
          <div id="kc-header-wrapper" className=" center">
            <div>Tranzit</div>
          </div>
        </div>
        <div className="card-pf">
          <header className="login-pf-header">
            <h1 id="kc-page-title center"> Sign in to your account</h1>
          </header>
          <div id="kc-content">
            <div id="kc-content-wrapper">
              <div id="kc-form">
                <div id="kc-form-wrapper">
                  <form id="kc-form-login">
                    <div className="form-group">
                      <label htmlFor="username" className="pf-c-form__label pf-c-form__label-text">
                        Username or email
                      </label>

                      <input
                        tabIndex="1"
                        id="username"
                        className="pf-c-form-control"
                        name="username"
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    {/* <div className="form-group">
                      <label htmlFor="password" className="pf-c-form__label pf-c-form__label-text">
                        Password
                      </label>

                      <input
                        tabIndex="2"
                        id="password"
                        className="pf-c-form-control"
                        name="password"
                        type="password"
                        autoComplete="off"
                        aria-invalid=""
                      />
                    </div> */}

                    <div className="form-group login-pf-settings">
                      <div id="kc-form-options"></div>
                      <div className=""></div>
                    </div>

                    <div id="kc-form-buttons" className="form-group">
                      {/* <input type="hidden" id="id-hidden-input" name="credentialId" />
                      <input
                        tabIndex="4"
                        className="pf-c-button pf-m-primary pf-m-block btn-lg"
                        name="login"
                        id="kc-login"
                        type="submit"
                        value="Sign In"
                      /> */}
                      <CButton
                        className="px-4 common-bg white-text next-btn"
                        onClick={goToKeyClockLogin}
                      >
                        Next
                      </CButton>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
